import CommonIcon from './common-icon'
export default CommonIcon